<script setup lang="ts">
const store = usePortfolioStore()
const svcBgs = ['from-[#ece3fb] to-[#e2d5f9]', 'from-[#fde9ef] to-[#fbdae3]', 'from-[#fdf4dc] to-[#fdf0cf]', 'from-[#e3ecfa] to-[#d7e3f8]']
const svcIcons = ['from-[#b797f6] to-[#9873ea]', 'from-[#f8a8c2] to-[#f18bb0]', 'from-[#f5ce6e] to-[#eeb944]', 'from-[#8fb0ef] to-[#6f96e6]']
const svcD = [
  'M12 3a9 9 0 000 18c1.2 0 2-.9 2-2 0-.5-.2-.9-.5-1.3-.3-.4-.5-.8-.5-1.2 0-1.1.9-2 2-2h2.4A4.6 4.6 0 0021 10c-.5-4-4.4-7-9-7zM6.5 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3.5-4a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm4.5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z',
  'M4.5 5h15A1.5 1.5 0 0121 6.5V16H3V6.5A1.5 1.5 0 014.5 5zM2 17.5h20v.5a2 2 0 01-2 2H4a2 2 0 01-2-2v-.5z',
  'M12 2.5l2.1 5.9 5.9 2.1-5.9 2.1L12 18.5l-2.1-5.9L4 10.5l5.9-2.1L12 2.5zM19 16l1 2.5L22.5 19 20 20l-1 2.5L18 20l-2.5-1 2.5-.5L19 16',
  'M13.5 2.5a.7.7 0 011.2.6L13.6 9h5a.7.7 0 01.5 1.2l-9.3 11.3a.7.7 0 01-1.2-.6l1.1-5.9h-5a.7.7 0 01-.5-1.2l9.3-11.3z'
]
</script>

<template>
  <section id="services" data-reveal class="rounded-[26px] p-5 shadow-[var(--t-clay)] [background:var(--t-sect4)]">
    <h2 class="text-base font-extrabold text-[var(--t-h14)]">خدمات من</h2>
    <ul class="mt-4 grid gap-2.5">
      <li v-for="(s, i) in store.services" :key="s.title"
          class="flex items-center gap-3 rounded-[20px] bg-gradient-to-b p-3.5
                 shadow-[inset_0_2px_3px_rgb(255_255_255/0.86),0_6px_12px_rgb(130_80_150/0.08)] transition duration-300 hover:-translate-y-0.5"
          :class="svcBgs[i % 4]">
        <span class="grid h-[42px] w-[42px] shrink-0 place-content-center rounded-[14px] bg-gradient-to-b text-white
                     shadow-[inset_0_3px_4px_rgb(255_255_255/0.55),inset_0_-4px_6px_rgb(70_40_140/0.28),0_6px_12px_rgb(90_60_160/0.25)]"
              :class="svcIcons[i % 4]">
          <svg viewBox="0 0 24 24" class="h-[18px] w-[18px] drop-shadow-[0_1.5px_1px_rgb(70_40_140/0.3)]" fill="currentColor"><path :d="svcD[i % 4]" /></svg>
        </span>
        <span class="grid min-w-0 gap-0.5">
          <span class="text-[13px] font-extrabold text-[var(--t-h14)]">{{ s.title }}</span>
          <span class="truncate text-[11.5px] text-[var(--t-soft4)]">{{ s.description }}</span>
        </span>
      </li>
    </ul>
  </section>
</template>
